import {NavLink, useLocation} from "react-router-dom";
import {publicUrlFor} from "../../../globals/constants";
import {useEffect, useState} from "react";
import {Link, animateScroll as scroll} from "react-scroll";
import {trackPhoneClick} from "../../../lib/gtag";
import {promo, slogan} from "../../../globals/data/home1";

function Header() {

  const [isActive, setIsActive] = useState(false);

  // Az akcio-sav csak az oldal tetejen latszik: amint gorgetni kezdunk,
  // osszecsukodik, hogy a sticky fejlec ne foglaljon felesleges helyet.
  const [atTop, setAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => setAtTop(window.scrollY < 10);
    handleScroll();
    window.addEventListener("scroll", handleScroll, {passive: true});
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function toggleNavClass() {
    setIsActive(!isActive)
  }

  const location = useLocation();

  const currentpath = location.pathname;

  // A fomenu pontjai a fooldal szekcioira mutatnak. Mas utvonalon (landing
  // oldalak, ASZF, adatvedelem, blog) ezert abszolut linkre valtunk, kulonben
  // a gorgetes nem talalna meg a celt.
  const isHome = currentpath === '/';

  const handleClickPhone = (phone) => {
    trackPhoneClick('AW-17491861595/GmBFCJ-yi5AbENvA4pRB', phone);
  };

  return (
    <header className={`site-header header-style-3 mobile-sider-drawer-menu ${isActive ? "active" : ""}`}>

      <div className="sticky-header main-bar-wraper navbar-expand-lg">
        <div className="main-bar">

          {/* Szezonalis akcio-sav. A promo objektum (globals/data/home1.js)
              active mezojevel kapcsolhato ki-be. Gorgetesre osszecsukodik,
              mobilon pedig csak a rovid valtozat latszik - lasd input.css. */}
          {promo.active && (
            <div className={`promo-bar${atTop ? "" : " is-hidden"}`} role="alert">
              <span className="promo-bar-inner">
                <b className="promo-bar-now">{promo.now}</b> <b>-{promo.percent}</b>
                {/* Kis kijelzon a rovid valtozat fut, kulonben levagodna a szoveg */}
                <span className="promo-bar-long"> kedvezmény minden szolgáltatásunkra!</span>
                <span className="promo-bar-short"> minden szolgáltatásra!</span>
                <span className="promo-bar-sep">|</span>
                <span className="promo-bar-slogan">{slogan}</span>
              </span>
            </div>
          )}

          <div className="container-fluid clearfix">

            <div className="logo-header border-r-solid border-r-[#fefefe3d] md:border-r-[1px] px-[60px]">
              <div className="logo-header-inner logo-header-one">
                <NavLink to="#">
                  {/* <img src={publicUrlFor("/assets/images/logo-dark.png")} alt="#" />*/}
                  <div className={"flex flex-column text-center"}>
                    <img className={'h-[20px] md:h-[60px] object-contain '}
                         src={publicUrlFor("/assets/images/icons/truck.png")} alt="truck"/>
                    <div
                      className={'text-[18px] md:text-[30px] text-bold leading-[18px] md:leading-[28px] text-[#fefefe]'}>
                      TELEPORT
                    </div>
                    <div
                      className={'text-[9px] md:text-[13px] bg-gradient-to-r from-[#efaf4d] to-[#eae244] bg-clip-text text-transparent'}>
                      Költöztetés - Bútorszállítás - Lomtalanítás
                    </div>
                  </div>
                </NavLink>
              </div>
            </div>

            {/* NAV Toggle Button */}
            <button id="mobile-side-drawer"
                    data-target=".header-nav"
                    data-toggle="collapse"
                    className="navbar-toggler collapsed"
                    onClick={toggleNavClass}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar icon-bar-first"></span>
              <span className="icon-bar icon-bar-two"></span>
              <span className="icon-bar icon-bar-three"></span>
            </button>

            {/* MAIN Vav */}
            <div className="nav-animation header-nav navbar-collapse collapse d-flex justify-content-center">

              <div className="nav navbar-nav">
                <li>
                  {!isHome ? (
                    <a
                      href="/#about-us"
                    >
                      Rólunk
                    </a>
                  ) : (
                    <Link
                      activeClass="active"
                      to="about-us"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setIsActive(false);
                      }}
                    >
                      Rólunk
                    </Link>
                  )}

                </li>

                <li>

                  {!isHome ? (
                    <a
                      href="/#services"
                    >
                      Szolgáltatásaink
                    </a>
                  ) : (
                    <Link
                      activeClass="active"
                      to="services"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setIsActive(false);
                      }}
                    >
                      Szolgáltatásaink
                    </Link>
                  )}
                </li>

                <li>
                  {!isHome ? (
                    <a
                      href="/#blogs"
                    >
                      Blog
                    </a>
                  ) : (
                    <Link
                      activeClass="active"
                      to="blogs"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setIsActive(false);
                      }}
                    >
                      Blog
                    </Link>
                  )}
                </li>

                <li>
                  {!isHome ? (
                    <a
                      href="/#faq"
                    >
                      GYIK
                    </a>
                  ) : (
                    <Link
                      activeClass="active"
                      to="faq"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setIsActive(false);
                      }}
                    >
                      GYIK
                    </Link>
                  )}
                </li>

                <li>
                  {!isHome ? (
                    <a
                      href="/#prices"
                    >
                      Áraink
                    </a>
                  ) : (
                    <Link
                      activeClass="active"
                      to="prices"
                      spy={true}
                      smooth={true}
                      offset={-70}
                      duration={500}
                      onClick={() => {
                        setIsActive(false);
                      }}
                    >
                      Áraink
                    </Link>
                  )}
                </li>

                <li>
                  {/* Az arajanlat-urlap a lablecben van, igy minden oldalon
                      letezik - itt mindig helyben gorgetunk. */}
                  <Link
                    activeClass="active"
                    to="quotation"
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                    onClick={() => {
                      setIsActive(false);
                    }}
                    className="h-bnr-btn rounded-[5px] mr-[15px] cursor-pointer"
                  >
                    Árajánlat
                  </Link>
                </li>
              </div>

            </div>

            {/* Header Right Section */}
            <div className="extra-nav header-2-nav">
              {/* <div className="extra-cell">
                                <div className="header-search">
                                    <a href="#search" className="header-search-icon"><i className="fa fa-search"></i> </a>
                                </div>
                            </div>*/}
              <div className="extra-cell">
                <div className="header-nav-call-section">


                  <div className="detail">
                    <span
                      style={{
                        color: '#fbb43e'
                      }}
                      className="title text-[#8c8aa3] text-[10px]">Hívjon minket most!</span>

                    <span><a
                      onClick={() => handleClickPhone('06706251650')}
                      href="tel:06706251650">+36 <span style={{color: '#fbb43e', display: 'inline-block'}}>70</span> 625 1650</a></span>
                    <span className={'mt-[10px]'}><a
                      onClick={() => handleClickPhone('06704093379')}
                      href="tel:06704093379">+36 <span style={{color: '#fbb43e', display: 'inline-block'}}>70</span> 409 3379</a></span>

                  </div>
                  <div className="media">
                    <img src={publicUrlFor("/assets/images/call.png")} alt="#"/>
                  </div>
                </div>
              </div>

            </div>

          </div>


        </div>

        {/* SITE Search */}
        <div id="search">
          <span className="close"></span>
          <form role="search" id="searchform" action="/search" method="get" className="radius-xl">
            <input className="form-control" name="q" type="search" placeholder="Type to search"/>
            <span className="input-group-append">
                            <button type="button" className="search-btn">
                                <i className="fa fa-paper-plane"></i>
                            </button>
                        </span>
          </form>
        </div>
      </div>

    </header>
  )
}

export default Header;